export const ONBOARDING_INSIGHTS = {
	CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
	AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
	AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
} as const;

export const InsightsOnboardingKeys = [...Object.values(ONBOARDING_INSIGHTS)] as const;
